import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {lastValueFrom} from "rxjs";
import {GoldenRecord} from "../Model/goldenRecord";

export interface GoldenRecordStage {
  catalogIds: string[];
  goldenRecordCatalogId: string;
}

@Injectable()
export class GoldenRecordService {
  private readonly apiUrl = 'api/GoldenRecord';

  constructor(private http: HttpClient) {}

  public getGoldenRecord(customerId: string): Promise<GoldenRecord> {
    const url = `${this.apiUrl}/getGoldenRecord`;
    const params = new HttpParams().append('customerId', customerId);
    return lastValueFrom(this.http.get<GoldenRecord>(url, { params }));
  }

  public getGoldenRecordStage(customerId: string): Promise<GoldenRecordStage> {
    const url = `${this.apiUrl}/getGoldenRecordStage`;
    const params = new HttpParams().append('customerId', customerId);
    return lastValueFrom(this.http.get<GoldenRecordStage>(url, { params }));
  }

  public setGoldenRecord(catalogId: string, customerId: string): Promise<any> {
    const url = `${this.apiUrl}/setGoldenRecord`;
    const params = new HttpParams()
      .append('catalogId', catalogId)
      .append('customerId', customerId);
    return lastValueFrom(this.http.post(url, null, { params }));
  }

  public removeCatalogFromStage(catalogId: string, customerId: string): Promise<any> {
    const url = `${this.apiUrl}/removeCatalogFromGoldenRecordStage`;
    const params = new HttpParams()
      .append('catalogId', catalogId)
      .append('customerId', customerId);
    return lastValueFrom(this.http.post(url, null, { params }));
  }

  public addCatalogToStage(catalogId: string, customerId: string): Promise<any> {
    const url = `${this.apiUrl}/addCatalogToGoldenRecordStage`;
    const params = new HttpParams()
      .append('catalogId', catalogId)
      .append('customerId', customerId);
    return lastValueFrom(this.http.post(url, null, { params }));
  }
}
